module.exports = __webpack_public_path__ + "img/pic-sound-on.199bd03.webp";